import "../style/homepage.css";
import React, { useState, useContext } from "react";
import Modal from "react-modal";
import "../style/search.css";
import "../style/tools.css"
import { AuthContext } from "../component/auth/auth";
import axios from "axios";
import { UserContext } from './UserContext';
import app from '../firebase/base.js';
import ai from '../assets/ai.png';
import subfinder from "../assets/subfinder.png"
import tcp from '../assets/tcp.png';
import udp from '../assets/udp.png';
import sql from '../assets/sql.jpeg';
import url from '../assets/url.png';
import dig from '../assets/dig.png';
import whatweb from '../assets/nuclei.png'
import nuclei from '../assets/whatweb.png';
import Tools from "./tools";


Modal.setAppElement("#root");



export function Search() {

  const [isOpen, setIsOpen] = useState(false);

  function toggleModal() {
    setIsOpen(!isOpen);
  }

  // create function to handle submit , on clcik send domain name , scan type and uid to backend using axios
  const [domain, setDomain] = useState("");
  const [scanType, setScanType] = useState("");
  const {userId, setUserId} = useContext(UserContext);
  const [name, setName] = useState('');
  const [mobileNo, setMobileNo] = useState('');
  const [email, setEmail] = useState('');

  const [responseData, setResponseData] = useState('')
  const { currentUser } = useContext(AuthContext);


  const getUserData = async () => {
    const userRef = app.firestore().collection("users").doc(userId);
    const doc = await userRef.get();
    if (!doc.exists) {
      console.log("No such document!");
    } else {
      // setName(doc.data().name);
      setMobileNo(doc.data().number);
      setEmail(doc.data().email);
      console.log("mobile no", mobileNo);
      console.log("Document data:", doc.data());
    }
  };



  const handleSubmit = (e) => {
    e.preventDefault();
    getUserData();
    loginCheck();
    console.log(domain, scanType);
    // send domain name , scan type and uid to backend using axios using url 

    axios.post(`http://20.254.94.18:8000/scan?domain=${domain}&scan_type=${scanType}&UID=${userId}&nom=${mobileNo}`
    )
      .then(res => {
        console.log(res);
        console.log("this is res data",res.data);

        setResponseData(res.data);
        clearInputs();
        
      })
      .catch(err => {
        console.log("this is error:",err);
        alert("Error in scanning")
      })
  }

  // assing input value to domain , scanType and uid
  const handleDomainChange = (e) => {
    setDomain(e.target.value);
  }
  const handleScanTypeChange = (e) => {
    setScanType(e.target.value);
  }


  const loginCheck = () => {
    if (userId) {
      console.log("user is logged in");
    }
    else {
      console.log("user is not logged in");
      alert("Something went wrong, UID not found \n possible reason:\n 1. user is not logged in \n 2. user is not registered \n 3. Connection error , please try again later");
    }
  }


  const clearInputs = () => {
    // console.log("this is response data",responseData);
    if(responseData === "Done"){
      alert("Scan is completed successfully \n You will receive a sms on registered number shortly !!");
      setScanType("");
      setDomain("");
    }
    else{
      console.log("I am from clearInput , Something went wrong, please try again later");
    }
  }






  return (
    <>
    <div className="search_container">
      <div className="first-section-left">
        
            <h1 className="gradient__text">Free Vulnerability Scanning & Penetration <br /> Testing Tool</h1> 
            <h3 >ScanEL provides FREE, easy-to-use tools for IT security teams to perform vulnerability assessments for web applications automatically and reliably. Protect current web assets by staying ahead of the cybersecurity game.</h3>
          <div className="input-div">
          <input className="input-field" placeholder="e.g. www.example.com" type="domain" onChange={handleDomainChange}></input>
          <input className="input-field" placeholder="Scan Type : whois, DIG" type="text" value={scanType} onChange={handleScanTypeChange}></input>
          <button onClick={handleSubmit} className="submit__btn" >Small Scan</button>

          </div>
     </div>
       <div className="scannel__ai-image">
           <img src={ai} />
       </div>
    </div>





{/* 
    <div className="tools">
           <div className="container_header">
                <h2 className="header_contaibner" >ScanEL Tools </h2>
            </div>
        <div className="AllTools">
           <div className="tools_container">
            
           <div className="Tools_image_div"> <img   className="Tools_image" src={subfinder}></img></div>
            <h2>Subdomain Finder</h2>
            <div className="tools_description" >
                <p>Finds associated subdomains in the organization</p>
            </div>
            <button  className="scan_button" onClick={()=>setScanType("subfinder")} > Scan</button>  
            </div>
            <div className="tools_container">
            
            <div className="Tools_image_div"> <img   className="Tools_image" src={tcp}></img></div>
             <h2>TCP Scan</h2>
             <div className="tools_description" >
                 <p className="tcp_scan">Checks for any open TCP Port    on your server </p>
             </div>
             <button  className="scan_button" onClick={()=>setScanType("nmap")}> Scan</button>  
             </div>

            <div className="tools_container">
            
           <div className="Tools_image_div"> <img   className="Tools_image" src={udp}></img></div>
            <h2>Whois</h2>
            <div className="tools_description" >
                <p></p>
                <p >Check for Registry and Registrar and other domain details</p>
            </div>
            <button  className="scan_button" onClick={()=>setScanType("whois")}> Scan</button>  
            </div>

            <div className="tools_container">
            
           <div className="Tools_image_div"> <img   className="Tools_image" src={sql}></img></div>
            <h2>SQL Scan</h2>
            <div className="tools_description" >
                <p>Verify the vulnerability of websites SQL injection attacks</p>
            </div>
            <button  className="scan_button" onClick={()=>setScanType("sqlscan")} > Scan</button>  
            </div>

            <div className="tools_container">
            
           <div className="Tools_image_div"> <img   className="Tools_image" src={url}></img></div>
            <h2>URL Fuzzing</h2>
            <div className="tools_description" >
                <p> find hidden files and directories on a web server by fuzzing</p>
            </div>
            <button  className="scan_button" onClick={()=>setScanType("fuzzing")} > Scan</button>  
            </div>


            <div className="tools_container">
            
            <div className="Tools_image_div"> <img   className="Tools_image" src={dig}></img></div>
             <h2>DIG</h2>
             <div className="tools_description" >
                 <p>A flexible tool for interrogating DNS name servers </p>
             </div>
             <button  className="scan_button"  onClick={()=>setScanType("dig")}> Scan</button>  
             </div>



             <div className="tools_container">
            
            <div className="Tools_image_div"> <img   className="Tools_image" src={nuclei}></img></div>
             <h2>Nuclei</h2>
             <div className="tools_description" >
                 <p>Used to send requests across targets based on a template </p>
             </div>
             <button  className="scan_button"  onClick={()=>setScanType("nuclei")} > Scan</button>  
             </div>



            <div className="tools_container">
            
            <div className="Tools_image_div"> <img   className="Tools_image" src={whatweb}></img></div>
             <h2>WhatWeb</h2>
             <div className="tools_description" >
                 <p>Identifies and recognizez all the web technologies available on the target website</p>
             </div>
             <button  className="scan_button"  onClick={()=>setScanType("whatweb")}> Scan</button>  
             </div>

        </div>


   
      </div> */}
</>
  );
}
